export default "__VITE_ASSET__DyL6pDAj__"